import React from "react";
import './guest.css';

export default function Cardprops(props) {
  return (
    <div
      class="gcard"
      data-aos="fade-up"
     data-aos-duration="1000"
    >
      <img src={props.image} alt="CardImage" />
      <div class="gcontent">
        <h3>{props.title}</h3>
        <h3>{props.date}</h3>
        <h1>{props.organiser}</h1>
        <p>{props.desc}</p>
      </div>
    </div>
  );
}
